// Chaves das queries da listagem de Vínculos Ativos (níveis 1 e 2). Ficam num
// arquivo próprio pra quem invalida (ex.: depois de um reprocessamento) usar a
// mesma chave de quem consulta, sem import circular entre index e EmpresaRow.
export const VINCULOS_EMPREGADORES_QUERY_KEY = "vinculos-empregadores";
export const EMPREGADOR_VINCULOS_QUERY_KEY = "empregador-vinculos";
// Listagem de Vínculos Encerrados (VinculosEncerradosPage).
export const VINCULOS_ENCERRADOS_QUERY_KEY = "vinculos-encerrados";
